import { render, staticRenderFns } from "./UserFamiliesCreateModal.vue?vue&type=template&id=16842f0a&scoped=true&"
import script from "./UserFamiliesCreateModal.vue?vue&type=script&lang=js&"
export * from "./UserFamiliesCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserFamiliesCreateModal.vue?vue&type=style&index=0&id=16842f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16842f0a",
  null
  
)

export default component.exports